import IApplicationState from 'app/types/state';
import _ from 'lodash';
import { getTeamPaymentCollectionIdsByPaymentId } from 'app/ducks/teamPaymentCollections/selectors';

import { ITeamPaymentRequestMetric } from 'app/ducks/teamPaymentRequestMetrics/types';

export const getTeamPaymentCollectionIds = (state: IApplicationState, teamPaymentRequestId) => getTeamPaymentCollectionIdsByPaymentId(state, teamPaymentRequestId);

export function getCurrentTeamPaymentRequestMetric(state: IApplicationState) {
  if (
    state.teamPaymentRequestMetrics.teamPaymentRequestMetricsById !== undefined
    && state.teamPaymentRequestMetrics.currentTeamPaymentRequestMetricId !== undefined
  ) {
    return state.teamPaymentRequestMetrics.teamPaymentRequestMetricsById[state.teamPaymentRequestMetrics.currentTeamPaymentRequestMetricId];
  }
  return {};
}

export function getTeamPaymentRequestMetricsFilteredByClubById(teamPaymentRequestMetricsById, clubId) {
  const filteredPayments = _.filter(teamPaymentRequestMetricsById, {
    club: { id: clubId },
  });
  const teamPaymentRequestIds = _.map(filteredPayments, 'id');
  const parsedPaymentsById = _.pick(teamPaymentRequestMetricsById, teamPaymentRequestIds);

  return {
    teamPaymentRequestMetricsById: parsedPaymentsById,
    teamPaymentRequestIds,
  };
}
export function parsePaymentStatus(teamPaymentRequestStatus): string {
  let status = 'In Progress';
  switch (teamPaymentRequestStatus) {
    case 'collected':
      status = 'Paid';
      break;
    case 'cancelled':
      status = 'Cancelled';
      break;
    default:
      status = 'In Progress';
      break;
  }
  return status;
}

// export function getTeamPaymentRequestMetricSummary(teamPaymentRequest: ITeamPaymentRequestMetric): any {
//   const teamPaymentRequestSummary = {
//     id: teamPaymentRequest.id,
//     summary: {
//       description: teamPaymentRequest.description,
//       numberOfTeamMembers: teamPaymentRequest.numberOfTeamMembers,
//     },
//     amount: teamPaymentRequest.amount,
//     status: teamPaymentRequest.status,
//     createdAt: teamPaymentRequest.createdAt,
//     collected: {
//       collected: teamPaymentRequest.collectedAmount,
//       total: teamPaymentRequest.totalAmount,
//     },
//     pendingTeamMembers: teamPaymentRequest.pending,
//   };
//   return teamPaymentRequestSummary;
// }

export function getCurrentFormPayment(state: IApplicationState) {
  return {
    ...getCurrentTeamPaymentRequestMetric(state),
    ...state.teamPaymentRequestMetrics.requestedData,
  };
}

export function getTeamPaymentRequestMetrics(state: IApplicationState) {
  return {
    ...state.teamPaymentRequestMetrics,
    currentTeamPaymentRequestMetric: {
      ...getCurrentTeamPaymentRequestMetric(state),
    },
  };
}

export function getTeamPaymentRequestMetricIdsByTeamId(teamPaymentRequestMetricsById: any, teamId) {
  if (teamPaymentRequestMetricsById !== undefined && teamId != null) {
    const filtered = _.filter(teamPaymentRequestMetricsById, { teamId });
    if (filtered != null) {
      return _.map(filtered, 'id');
    }
    return [];
  }
  return [];
}
export function getTeamPaymentRequestMetricIdsByClubId(teamPaymentRequestMetricsById: any, clubId) {
  if (teamPaymentRequestMetricsById !== undefined && clubId != null) {
    const filtered = _.filter(teamPaymentRequestMetricsById, { clubId });
    if (filtered != null) {
      return _.map(filtered, 'id');
    }
    return [];
  }
  return [];
}
